/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMarketScreenDataRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {GetMarketScreenDataResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const getMarketScreenData = (request: GetMarketScreenDataRequest, options?: CashRequestOptions) => post<GetMarketScreenDataRequest, GetMarketScreenDataResponse>("/2.0/cash/get-market-screen-data", request, {...options, rejectOnError: true })